import { distinctUntilChanged, filter } from 'rxjs/operators';
import { EventEmitter, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { UXFacet } from '../../models/ux-facets';
var FacetComponent = /** @class */ (function () {
    function FacetComponent() {
        this.applied = false;
        this.facetToggled = new EventEmitter();
        this.checkBoxControl = new FormControl();
    }
    Object.defineProperty(FacetComponent.prototype, "isApplied", {
        set: function (value) {
            this.applied = value;
            this.checkBoxControl.setValue(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FacetComponent.prototype, "name", {
        get: function () {
            return this.facet.name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FacetComponent.prototype, "idByGroup", {
        get: function () {
            return this.facet.group.trim() + this.facet.name.trim();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FacetComponent.prototype, "count", {
        get: function () {
            return this.facet.count;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FacetComponent.prototype, "notApplicable", {
        get: function () {
            return !this.applied && this.count === 0;
        },
        enumerable: true,
        configurable: true
    });
    FacetComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.notApplicable
            ? this.checkBoxControl.disable()
            : this.checkBoxControl.enable();
        this.checkBoxControl.valueChanges.pipe(filter(function (value) { return value !== _this.applied; }), distinctUntilChanged())
            .subscribe(this.toggled.bind(this));
    };
    FacetComponent.prototype.toggled = function () {
        this.facetToggled.emit({
            code: this.facet.code,
            group: this.facet.group
        });
    };
    return FacetComponent;
}());
export { FacetComponent };
